import { render } from "./RiError.vue?vue&type=template&id=297afe8b"
import script from "./RiError.vue?vue&type=script&lang=js"
export * from "./RiError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "297afe8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('297afe8b', __exports__)) {
    api.reload('297afe8b', __exports__)
  }
  
  module.hot.accept("./RiError.vue?vue&type=template&id=297afe8b", () => {
    api.rerender('297afe8b', render)
  })

}


export default __exports__